import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TextField } from '@eventlyte/forms';
import { RegistrationStepperControls, RegistrationStepperProgress } from '@eventlyte/registration';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCalendar, faMapPin } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoDirective } from '@jsverse/transloco';
import { AppRoutePaths } from '../../app.routes';
import { LocalRegistrationPageBase } from '../../shared/local-registration-page-base';
import { RegistrationConfirmationBadge } from './registration-confirmation-badge/registration-confirmation-badge';

@Component({
	selector: 'app-registration-confirmation-page',
	imports: [
		RegistrationStepperControls,
		RegistrationStepperProgress,
		TranslocoDirective,
		TextField,
		RegistrationConfirmationBadge,
		FontAwesomeModule
	],
	templateUrl: './registration-confirmation-page.html'
})
export class RegistrationConfirmationPage extends LocalRegistrationPageBase {
	protected override currentStepNumber = 4;
	protected formGroup = new FormGroup({});
	protected icons = { faMapPin, faCalendar };

	public ngAfterViewInit(): void {
		this.activatedRoute.queryParamMap.pipe(this.takeUntilDestroyed()).subscribe((params) => {
			if (params.get('ref') && params.get('id')) {
				this.registrationService.info(params.get('id')!, params.get('ref')!).subscribe({
					next: (registration) => {
						if (registration) {
							this.record.set(registration.record);
							this.isLoading.set(false);
						} else {
							this.router.navigate([AppRoutePaths.LandingPage]);
						}
					},
					error: () => {
						this.router.navigate([AppRoutePaths.LandingPage]);
					}
				});
			}
		});
	}
}
